import type { BetaSearch } from '../repositories/betaSearchRepository';

/** A search text as feeds compare it: trimmed, inner whitespace collapsed, lower case. */
export function normalizedSearchText(text: string): string {
  return text.trim().replace(/\s+/g, ' ').toLowerCase();
}

/** The reader's saved feed whose prompt is *text*, if any: saving that search updates it instead of adding a copy. */
export function matchingSavedFeed(feeds: BetaSearch[], text: string): BetaSearch | undefined {
  const target = normalizedSearchText(text);
  return target ? feeds.find(feed => normalizedSearchText(feed.description) === target) : undefined;
}
